import { render } from "./ownerOrganicForm.vue?vue&type=template&id=71b5461e"
import script from "./ownerOrganicForm.vue?vue&type=script&lang=js"
export * from "./ownerOrganicForm.vue?vue&type=script&lang=js"

import "./ownerOrganicForm.vue?vue&type=style&index=0&id=71b5461e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__